import type { CheckoutConfig } from '#types/config/components/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  dialogOptions: { type: 'panel' }
} satisfies RecursivePartial<CheckoutConfig['shippingAndDelivery']>
